import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe } from '../api';
import { getAccessToken, setTokens, clearTokens, isAuthFailure } from '../api/authClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getAccessToken()) {
      setLoading(false);
      return;
    }
    getMe()
      .then((res) => setUser(res.data))
      .catch((err) => {
        // Only drop the session when the server actually rejected us. A blip
        // while the API is restarting used to sign the user out for good.
        if (isAuthFailure(err)) clearTokens();
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (credentials) => {
    const { data } = await apiLogin(credentials);
    setTokens({ access: data.access, refresh: data.refresh });
    const me = await getMe();
    setUser(me.data);
    return me.data;
  };

  const logout = () => {
    // Clear auth only — the guest cart and UI prefs are not credentials.
    clearTokens();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin: user?.is_staff || user?.is_superuser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
